import React, { useEffect, useState } from "react";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import Slider from "components/Slider";
import Input from "components/Input";
import Checkbox from "components/Checkbox";
import { useQuery } from "@apollo/client";
import { GET_ALL_HOTEL_CHARGES } from "graphql/service";
import { Content, ItemContainer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";

const RatePlan = () => {

  const [hotelCharges, setHotelCharges] = useState({});

  const { data: hotelChargesData, error } = useQuery(GET_ALL_HOTEL_CHARGES);

  useEffect(() => {
    if (hotelChargesData) {
      setHotelCharges(hotelChargesData.hotelChargesSettings);
    }
  }, [hotelChargesData]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes("Validation")) {
        content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception);
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  return (
    <Card
      additionalstyle={`
        height: auto;
        align-self: flex-start;
      `}
    >
      <CardHeader>
        <div className="cardTitle">HOTEL CHARGES</div>
      </CardHeader>
      <Content>
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">Early Check In Fee</span>
            <span className="slider">
              <Slider
                checked={hotelCharges.earlyCheckin?.enabled}
                onActivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      earlyCheckin: {
                        ...prev.earlyCheckin,
                        enabled: true,
                      },
                    };
                  });
                }}
                onDeactivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      earlyCheckin: {
                        ...prev.earlyCheckin,
                        enabled: false,
                      },
                    };
                  });
                }}
              />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={hotelCharges.earlyCheckin?.amount || 0}
              active={hotelCharges.earlyCheckin?.enabled}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    earlyCheckin: {
                      ...prev.earlyCheckin,
                      amount: e.target.value,
                    },
                  };
                })
              }}
            />
          </div>
        </ItemContainer>
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">Late Check Out Fee</span>
            <span className="slider">
              <Slider
                checked={hotelCharges.lateCheckout?.enabled}
                onActivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      lateCheckout: {
                        ...prev.lateCheckout,
                        enabled: true,
                      },
                    };
                  });
                }}
                onDeactivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      lateCheckout: {
                        ...prev.lateCheckout,
                        enabled: false,
                      },
                    };
                  });
                }}
              />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={hotelCharges.lateCheckout?.amount || 0}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    lateCheckout: {
                      ...prev.lateCheckout,
                      amount: e.target.value,
                    },
                  };
                });
              }}
            />
          </div>
        </ItemContainer>
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">Parking (Per Night)</span>
            <span className="slider">
              <Slider
                checked={hotelCharges.parking?.enabled}
                onActivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      parking: {
                        ...prev.parking,
                        enabled: true,
                      },
                    };
                  });
                }}
                onDeactivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      parking: {
                        ...prev.parking,
                        enabled: false,
                      },
                    };
                  });
                }}
              />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={hotelCharges.parking?.amount || 0}
              active={hotelCharges.parking?.enabled}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    parking: {
                      ...prev.parking,
                      amount: e.target.value,
                    },
                  };
                });
              }}
            />
          </div>
        </ItemContainer>{" "}
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">Breakfast (Per Day)</span>
            <span className="slider">
              <Slider
                checked={hotelCharges.breakfast?.enabled}
                onActivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      breakfast: {
                        ...prev.breakfast,
                        enabled: true,
                      },
                    };
                  });
                }}
                onDeactivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      breakfast: {
                        ...prev.breakfast,
                        enabled: false,
                      },
                    };
                  });
                }}
              />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={ hotelCharges.breakfast?.amount || 0}
              active={hotelCharges.breakfast?.enabled}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    breakfast: {
                      ...prev.breakfast,
                      amount: e.target.value,
                    },
                  };
                });
              }}
            />
          </div>
        </ItemContainer>
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">No Show Fee</span>
            <span className="slider">
              <Slider
                checked={hotelCharges.noShow?.enabled}
                onActivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      noShow: {
                        ...prev.noShow,
                        enabled: true,
                      },
                    };
                  });
                }}
                onDeactivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      noShow: {
                        ...prev.noShow,
                        enabled: false,
                      },
                    };
                  });
                }}
              />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={hotelCharges.noShow?.amount || 0}
              active={hotelCharges.noShow?.enabled}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    noShow: {
                      ...prev.noShow,
                      amount: e.target.value,
                    },
                  };
                });
              }}
            />
            <Checkbox
              mainPage
              title="Use one room night"
              checked={hotelCharges.noShow?.useOneRoomNight}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    noShow: {
                      ...prev.noShow,
                      useOneRoomNight: e.target.checked,
                    },
                  };
                });
              }}
            />
          </div>
        </ItemContainer>
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">Overstay Penalty</span>
            <span className="slider">
              <Slider
                checked={hotelCharges.overstay?.enabled}
                onActivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      overstay: {
                        ...prev.overstay,
                        enabled: true,
                      },
                    };
                  });
                }}
                onDeactivate={() => {
                  setHotelCharges((prev) => {
                    return {
                      ...prev,
                      overstay: {
                        ...prev.overstay,
                        enabled: false,
                      },
                    };
                  });
                }}
              />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={hotelCharges.overstay?.amount || 0}
              active={hotelCharges.overstay?.enabled}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    overstay: {
                      ...prev.overstay,
                      amount: e.target.value,
                    },
                  };
                });
              }}
            />
            <Checkbox
              mainPage
              title="Use one room night"
              checked={hotelCharges.overstay?.useOneRoomNight}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    overstay: {
                      ...prev.overstay,
                      useOneRoomNight: e.target.checked,
                    },
                  };
                }); 
              }}
            />
          </div>
        </ItemContainer>
      </Content>
    </Card>
  );
};

export default RatePlan;
